import { useEffect, useState } from 'react';
import { DEFAULT_WHATSAPP_NUMBER } from '../utils/whatsapp';

const buildDefaultWhatsappApiUrl = () => {
    if (typeof window === 'undefined') {
        return 'http://localhost:3000/api/whatsapp-config';
    }

    const adminPort = window.location.port === '3000' ? '3002' : '3000';
    return `${window.location.protocol}//${window.location.hostname}:${adminPort}/api/whatsapp-config`;
};

export default function useWhatsappNumber() {
    const [number, setNumber] = useState(DEFAULT_WHATSAPP_NUMBER);

    useEffect(() => {
        const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
        const shouldUseAdminApi =
            hostname === 'alarmitastaging.netlify.app' ||
            hostname === 'alarmita.com' ||
            hostname === 'www.alarmita.com';
        const url = shouldUseAdminApi
            ? 'https://admin.alarmita.com/api/whatsapp-config'
            : process.env.REACT_APP_WHATSAPP_CONFIG_URL || buildDefaultWhatsappApiUrl();

        let cancelled = false;
        const controller = new AbortController();
        const timeoutHandle = window.setTimeout(() => controller.abort(), 1500);

        fetch(url, { cache: 'no-store', signal: controller.signal })
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
                if (!cancelled && data?.number) {
                    setNumber(data.number);
                }
            })
            .catch(() => {
                // Mantiene DEFAULT_WHATSAPP_NUMBER si falla o no llega a tiempo.
            })
            .finally(() => {
                window.clearTimeout(timeoutHandle);
            });

        return () => {
            cancelled = true;
            window.clearTimeout(timeoutHandle);
            controller.abort();
        };
    }, []);

    return number;
}
